// import React from "react";

// const Webbanner = () => {
//   const bannerStyles = {
//     marginTop:"60px",
//     width: "100%",
//     height: "90vh", 
//     backgroundImage: "url('/image/webbb.jpg')",  
//     backgroundSize: "cover",
//     backgroundPosition: "center center",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     textAlign: "center",
//     color: "white",
//     position: "relative",
//     overflow: "hidden",
//   };

//   const contentStyles = {
//     maxWidth: "90%",
//     padding: "0 20px",  
//   };

//   const headingStyles = {
//     fontSize: "4rem",  
//     margin: 0,
//     lineHeight: 1.2,
//     fontWeight: "bold",
//   };

//   const paragraphStyles = {
//     fontSize: "1.5rem",  
//     marginTop: "1rem",
//   };

  
//   const mediaQueryStyles = {
//     "@media (max-width: 1200px)": {
//       heading: { fontSize: "3.5rem" },
//       paragraph: { fontSize: "1.3rem" },
//     },
//     "@media (max-width: 768px)": {
//       heading: { fontSize: "2.5rem" },
//       paragraph: { fontSize: "1.2rem" },
//     },
//     "@media (max-width: 480px)": {
//       heading: { fontSize: "2rem" },
//       paragraph: { fontSize: "1rem" },
//     },
//   };

//   return (
//     <div style={bannerStyles}>
//       <div style={contentStyles}>
       
        
//       </div>
//     </div>
//   );
// };

// export default Webbanner;




import React from "react";
import { motion } from "framer-motion";

const Webbanner = () => {
  const bannerStyles = {
   // marginTop: "60px",
    width: "100%",
    height: "90vh",
    backgroundImage: "url('/image/webbb.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    display: "flex",
    justifyContent: "flex-start",  
    alignItems: "center",  
    color: "white",
    position: "relative",
    overflow: "hidden",
    paddingLeft: "60px",  
  };

  const textStyles = {
    fontSize: "2rem",
    fontWeight: "bold",
    lineHeight: "1.1", 
    textAlign: "left",
    letterSpacing: "0px",
    color:"white",
  };

  return (
    <div style={bannerStyles}>
      <motion.div
        initial={{ y: 80, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1.2, ease: "easeOut" }}
      >
        <h2 style={textStyles}>
          Crafting Modern Web Experiences <br />
          With Innovation & Simplicity
        </h2>
      </motion.div>
    </div>
  );
};

export default Webbanner;
